<template>
  <div class="ui padded grid">
    <nav-back-office-top></nav-back-office-top>
    <div class="ui active loader" v-if="loadingState !== true"></div>
    <!--TODO: Remove test Env in production-->
    <div v-if="testEnv === true" >
      <div class="ui primary button" @click="addStudyPartipant">Randomly add 1 study participant</div>
    </div>
    <div class="sixteen wide column" v-if="loadingState === true">
      <table class="ui celled striped large table">
        <thead>
        <tr>
          <th class="fitted">Medgate ID</th>
          <th class="center aligned">Day 0</th>
          <th class="center aligned">Day 30</th>
          <th class="center aligned">Day 120</th>
          <th class="center aligned">Day 210</th>
          <th class="center aligned">Day 300</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(patient, key) in studyResponses"
            v-if="userIdToMedgateId[key]">
          <td>{{ userIdToMedgateId[key].medgateId }}</td>
          <td class="center aligned">
            <i v-if="patient.hasOwnProperty('dayminus30') && patient.dayminus30.answered === true" class="green checkmark icon"></i>
            <router-link v-else
                         :to="{ name: 'PageAssessment', params: {checkpoint: 'dayminus30', patient: userIdToMedgateId[key] } }">
              <i class="pencil alternate icon"></i> Fill Now
            </router-link>
          </td>
          <td class="center aligned">
            <i v-if="patient.hasOwnProperty('day0') && patient.day0.answered === true" class="green checkmark icon"></i>
            <router-link v-else
              :to="{ name: 'PageAssessment', params: {checkpoint: 'day0', patient: userIdToMedgateId[key] } }">
              <i class="pencil alternate icon"></i> Fill Now
            </router-link>
          </td>
          <td class="center aligned">
            <i v-if="patient.hasOwnProperty('day90') && patient.day90.answered === true" class="green checkmark icon"></i>
            <router-link v-else
              :to="{ name: 'PageAssessment', params: {checkpoint: 'day90', patient: userIdToMedgateId[key] }}">
              <i class="pencil alternate icon"></i> Fill Now
            </router-link>
          </td>
          <td class="center aligned">
            <i v-if="patient.hasOwnProperty('day180') && patient.day180.answered === true" class="green checkmark icon"></i>
            <router-link v-else
              :to="{ name: 'PageAssessment', params: {checkpoint: 'day180', patient: userIdToMedgateId[key] }}">
              <i class="pencil alternate icon"></i> Fill Now
            </router-link>
          </td>
          <td class="center aligned">
            <i v-if="patient.hasOwnProperty('day270') && patient.day270.answered === true" class="green checkmark icon"></i>
            <router-link v-else
              :to="{ name: 'PageAssessment', params: {checkpoint: 'day270', patient: userIdToMedgateId[key] }}">
              <i class="pencil alternate icon"></i> Fill Now
            </router-link>
          </td>
          </tr>
        </tbody>
      </table>

    </div>
  </div>
</template>

<script>
  import { mapState} from 'vuex'
  import NavBackOfficeTop from '../NavBackOfficeTop.vue'
	export default {
    components: {
      NavBackOfficeTop
    },
    props: {

    },
		data() {
			return {
			  loadingState: null,
        studyResponses: []
      }
		},
		computed: {
      ...mapState(['userIdToMedgateId','userId']),
      testEnv: function(){
        return (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'beta' && process.env.NODE_ENV !== 'staging' && process.env.NODE_ENV !== 'medgate')
      }
    },
		methods: {
      addStudyPartipant: function() {
        let requestUrl = process.env.API_STUDYCONSENT_URL + '?study_name=' + process.env.STUDY_NAME + '&userid=' + Date.now() + '&lang=en&country=CH';

        this.$http.post(requestUrl).then((response) => {
          window.location.reload();
        })
      },

      getStudySummary: function() {
        let authUrl = process.env.PROXY_URL + this.userId;
        let requestUrl = process.env.QB_URL + 'studies/summary/?study_name=' + process.env.STUDY_NAME;


        this.$http.get(authUrl, {
          headers: {
            'request-url': requestUrl
          }
        }).then( (response) => {
          this.studyResponses = JSON.parse(response.body).data;

          //A hack but don't remove it :)
          window.setTimeout(()=>{
            this.loadingState = true;
          }, 300);


        })
      }
    },
    watch: {

    },
		mounted() {
      $('.ui.dropdown').dropdown();
      this.getStudySummary();
		}
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/assessment/TabAssessment.vue